import React, { useEffect, useState } from "react";
import { Button, Card, CardBody, CardHeader, Col, Container, Row, Spinner, Input } from "reactstrap";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import { useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { getAuthUser } from "../../../helpers/utils";
import { useDispatch, useSelector } from "react-redux";
import { fetchAttemptScoreTableColumnNames, fetchAllAttemptScore, createAttemptScore, updateAttemptScore, 
    deleteAttemptScore, activateDeactivateAttemptScore, updateUserPreference} from "../../../slices/thunks";
import ColumnSelectionModal from "../../../Components/Common/ColumnSelectionModal/ColumnSelectionModal";
import CommonTable from "../../../Components/Common/Table/CommonTable";
import DeleteModal from "../../../Components/Common/DeleteModal";
import AddModal from "../../../Components/Common/Modal/AddModal";
import AddCommonForm2 from "../../../Components/Common/AddCommonForm/AddCommonForm2";
import CommonDataTable from "../../../Components/Common/Table/CommonDataTable";
import AddCommonForm from "../../../Components/Common/AddCommonForm/AddCommonForm";
import CommonAddModal from "../../../Components/Common/Modal/CommonAddModal";
import usePermissions from "../../../Components/Hooks/usePermissions";


const labels = [
  {
    id: 1,
    labelName: "Attempt",
    fieldName: "number-box",
    name: "Attempt",
    value: "Attempt",
    required: true,
    errorMessage: "Please Enter Attempt"
  },
  {
    id: 2,
    labelName: "Attempt Score",
    fieldName: "number-box",
    name: "AttemptScore",
    value: "AttemptScore",
    required: true,
    errorMessage: "Please Enter Attempt Score"
  },
  {
    id: 3,
    labelName: "View Solution Score",
    fieldName: "number-box",
    name: "ViewScore",
    value: "ViewScore",
    required: true,
    errorMessage: "Please Enter View Solution Score"
  }
]

const actionConfig = {
  edit: {
    icon: "ri-edit-2-line",
    tooltip: "Edit",
  },
  delete: {
    icon: "ri-delete-bin-2-line",
    tooltip: "Delete",
  },
};


function AttemptScore () {
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation();
  const user = getAuthUser();
  const [show, setShow] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [isAddOrEdit, setIsAddOrEdit] = useState("isAdd");
  const [selectedRow, setSelectedRow] = useState({});
  const [selectedIds, setSelectedIds] = useState([]);
  const [deleteModal, setDeleteModal] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedColumns, setSelectedColumns] = useState([]);

  const { AttemptScore, tableColumnNames, loading, Headerload, module } = useSelector((state) => ({
    AttemptScore: state.AttemptScore.attemptScore,
    tableColumnNames: state.AttemptScore.tableColumnNames,
    loading: state.AttemptScore.loading,
    Headerload: state.AttemptScore.Headerload,
    module: state.Module.module,
  }));

   // Compute permission
  const permission = (() => {
    return usePermissions(2, 16);
  })();

  const onAddClickHandler = (value) => {
    setShow(true);
    setIsAddOrEdit(value);
    setSelectedRow({});
  };

  const onEditClickHandler = (attemptScore, value) => {
    setSelectedRow(attemptScore);
    setIsAddOrEdit(value);
    setShow(true);
  };
  
  
  const onSubmitHandler = (values, { resetForm }) => {

    const attemptScoreObj = {
      Attempt: values.Attempt,
      AttemptScore: values.AttemptScore,
      ViewScore: values.ViewScore
    };

    if (isAddOrEdit === "isEdit") {
        attemptScoreObj.ID = selectedRow?.ID;
    }

    isAddOrEdit === "isAdd" ?
      dispatch(createAttemptScore(attemptScoreObj)) :
      dispatch(updateAttemptScore(attemptScoreObj));

    resetForm();
    setShow(false);
  };

  const handleSave = async () => {
    const preferencesPayload = {
      UserId: user.UserId,
      ColumnIDs: tableColumnNames.reduce((acc, column) => {
        acc[column.ColumnId] = selectedColumns.includes(column.ColumnId);
        return acc;
      }, {}),
    };
    setModalOpen(false);

    try {
      await dispatch(updateUserPreference(preferencesPayload)).unwrap();
      await dispatch(fetchAttemptScoreTableColumnNames({ module: "ATTEMPTSCORE" }))
      await dispatch(
        fetchAllAttemptScore({
          module: "ATTEMPTSCORE"
        })
      );
    } catch (error) {
      console.error("Error updating preferences:", error);
    }
  };

  const confirmDelete = () => {
    dispatch(deleteAttemptScore({ Ids: selectedIds, UserId: user.UserId }))
      .then(() => {
        setSelectedIds([]);
      })
      .catch((error) => {
        console.error("Error deleting:", error);
      });
    setDeleteModal(false);
  };

  const onActiveOrDeactiveChange = (attemptScore, e) => {
    dispatch(activateDeactivateAttemptScore({ ID: attemptScore.ID, IsActive: attemptScore.IsActive, UserId: user.UserId }));
  };

  useEffect(() => {
    dispatch(fetchAttemptScoreTableColumnNames({ module: "ATTEMPTSCORE" }))
    dispatch(fetchAllAttemptScore());

  }, [dispatch]);

  return (
    <div className="page-content">
      <Container fluid>
        <Row className="mb-3">
          <Col>
            <BreadCrumb title={t('Attempt Score')} />
          </Col>
        </Row>
        <div className="table-responsive">
          <Card>
            <CardHeader>
               <Row className="g-4 ">
                  <Col className="col-sm-auto">
                    <div>
                      <Button
                        className="btn btn-soft-danger ms-2 me-2"
                        onClick={() => setDeleteModal(true)}
                        disabled={selectedIds.length === 0}
                      >
                        <i className="ri-delete-bin-2-line"></i>
                      </Button>
                      {permission.CanAdd && (
                        <Button
                          color="secondary"
                          className="add-btn me-1"
                          onClick={() => onAddClickHandler("isAdd")}
                          id="create-btn"
                          disabled={loading}
                        >
                          <i className="ri-add-line align-bottom me-1 ms-1"></i>
                          {t("AddNew")}
                        </Button>
                      )}
                    </div>
                  </Col>
                  <Col className="col-sm">
                    <div className="d-flex justify-content-sm-end">
                      <Button
                        className="btn btn-soft"
                        onClick={() => setModalOpen(true)}
                        disabled={loading}
                      >
                        <i className="ri-filter-3-line"></i>
                      </Button>
                      <div className="search-box ms-2 me-2">
                        <Input
                          type="text"
                          className="form-control search"
                          placeholder={t("Search")}
                          value={searchTerm}
                          onChange={(e) => setSearchTerm(e.target.value)}
                        />
                        <i className="ri-search-line search-icon"></i>
                      </div>
                    </div>
                  </Col>
                </Row>
            </CardHeader>

            <CardBody>
              <div className="listjs-table" id="customerList">
                {loading || Headerload ? (
                  <div className="d-flex justify-content-center align-items-center">
                  <Spinner style={{ height: "3rem", width: "3rem" }} className="me-2">
                    Loading...
                  </Spinner>
                  </div>
                ) : (
                  <div className="listjs-table" id="customerList">
                    {/* <CommonTable
                      data={AttemptScore}
                      tableColumnNames={tableColumnNames}
                      searchTerm={searchTerm}
                      onEditClickHandler={onEditClickHandler}
                      onActiveOrDeactiveChange={onActiveOrDeactiveChange}
                      setDeleteModal={setDeleteModal}
                      setSelectedIds={setSelectedIds}
                      hasAction={true}
                      permission={permission}
                    /> */}
                    <CommonDataTable
                      data={AttemptScore}
                      tableColumnNames={tableColumnNames}
                      searchTerm={searchTerm}
                      onEditClickHandler={onEditClickHandler}
                      onActiveOrDeactiveChange={onActiveOrDeactiveChange}
                      setDeleteModal={setDeleteModal}
                      setSelectedIds={setSelectedIds}
                      actionConfig={actionConfig}
                      permission={permission}
                    />
                  </div>
                )}
              </div>
            </CardBody>
          </Card>
        </div>
      </Container>

      {/* Modal  */}
       <CommonAddModal
        show={show}
        setShow={setShow}
        onSubmitHandler={onSubmitHandler}
        labels={labels}
        isAddOrEdit={isAddOrEdit}
        selectedItemData={selectedRow}
        FormBody={AddCommonForm}
        // FormBodyProps={{ onTranslateClickHandler, translationLoading, lastTranslatedField }} 
        title={isAddOrEdit === "isAdd" ? t("Add New Attempt Score") : t("Edit Attempt Score")} 
        size="lg"
      />

      {/* ColumnSelectionModal */}
      <ColumnSelectionModal
        isOpen={modalOpen}
        toggle={() => setModalOpen(!modalOpen)}
        columns={tableColumnNames}
        selectedColumns={selectedColumns}
        setSelectedColumns={setSelectedColumns}
        handleSave={handleSave}
      />

      {/* Delete modal  */}
      <DeleteModal
        showDelete={deleteModal}
        setShowDelete={setDeleteModal}
        onDeleteClick={confirmDelete}
        setSelectedIds={setSelectedIds}
        description={
          selectedIds.length > 1
            ? `Are you sure you want to delete ${selectedIds.length} selected items?`
            : `Are you sure you want to delete this record?`
        }
      />
    </div>
  );
}

export default AttemptScore;